import React, {useEffect} from 'react';
import cx from 'classnames';
import styles from './Drawer.module.scss';

function Drawer(props) {
  const {isOpen, children, toggle, direction} = props;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  return (
    <div className={cx(styles.drawer, {[styles['drawer--open']]: isOpen})}>
      {isOpen && (
        <div className={styles['drawer--backdrop']} onClick={toggle} />
      )}
      <div
        className={cx(styles[`drawer--contents-${direction}`], {
          [styles[`drawer--contents-${direction}--open`]]: isOpen,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default Drawer;
